import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { GiPlayerNext, GiPlayerPrevious } from "react-icons/gi";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import ModalContainer from "../ModalContainer";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import { Description, SubTitle } from "../CustomComponents";
import CommentShimmer from "../Shimmers/comment_shimmer";
import { formatedDate } from "../../constants";
import cssStyles from "./styles/viewPostModal.module.scss";
import { useGetFeedbackDetailsQuery } from "../../Data/services/faqApi";
import CustomSpinner from "../CustomComponents/CustomSpinner";
import BeatLoader from "react-spinners/BeatLoader";

const UserFeedbackDtlModal = ({ handleViewModalClose, id }) => {
  const swiperRef = useRef(null);
  const [comments, setComments] = useState([]);
  const [activeImage, setActiveImage] = useState("");
  const { data, isLoading } = useGetFeedbackDetailsQuery({
    id: id,
  });

  console.log(data);

  const dynamicData = data?.data || [];

  const renderFeedback = (feedbackData) => {
    return feedbackData.map((session, sessionIndex) => (
      <div key={sessionIndex} className="mb-4">
        {session.data.map((item, index) => (
          <div key={index} className="mb-3">
            <h5 className="black-text">{item.feedback_question}</h5>
            <p className="text-black-50">{item.answer}</p>
            <small className="text-muted">{formatedDate(item.createdAt)}</small>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div>
      <ModalContainer handleClose={handleViewModalClose}>
        <div className={cssStyles.modalContainer} style={{maxWidth: "75%"}}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">View Details</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleViewModalClose}
                style={{ cursor: "pointer", color: "black" }}
              />
            </span>
          </div>

          <Row className="w-100 h-100">
            <Col md={12} sm={12} className="">
              <div className="d-flex flex-column justify-content-start align-items-top w-100 h-100">
                <hr />

                <SubTitle classes="lc-1 fs-5 mb-4 black-text" text="Feedback" />

                {isLoading && <div className="text-center w-100"><BeatLoader className="primary-text" /></div>}

                {dynamicData.length > 0
                  ? renderFeedback(dynamicData)
                  : !isLoading && (
                      <Description
                        classes="my-2 black-text"
                        text="No feedback found."
                      />
                    )}
              </div>
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default UserFeedbackDtlModal;
